import { convertGeoAddressToOLOAddress } from './functions';

export class PlaceResolutionError extends Error {
  constructor(message: string, public status?: google.maps.places.PlacesServiceStatus) {
    super(message);
    this.name = 'PlaceResolutionError';
  }
}

export async function resolvePlace(
  placeId: string,
  sessionToken: google.maps.places.AutocompleteSessionToken
): Promise<{ address: IDeliveryAddress; lat: number; lng: number }> {
  const host = document.createElement('div');
  const service = new google.maps.places.PlacesService(host);

  return new Promise((resolve, reject) => {
    service.getDetails(
      {
        placeId,
        sessionToken,
        fields: ['geometry.location', 'address_components'],
      },
      (place, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
          reject(new PlaceResolutionError(`Place details failed: ${status}`, status));
          return;
        }
        const location = place?.geometry?.location;
        if (!location || !place?.address_components) {
          reject(new PlaceResolutionError('Place details missing geometry or address_components'));
          return;
        }
        resolve({
          address: convertGeoAddressToOLOAddress(place.address_components),
          lat: location.lat(),
          lng: location.lng(),
        });
      }
    );
  });
}
